import React from "react";
import { Form } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { FieldHeader } from "../../components/FieldHeader";

function CheckboxWidget(props: any) {
  const { id, value, label, formContext } = props;
  const { t, globalT } = useSchemaTranslation();

  const checked = value == "true" || value == true;

  const texts = {
    yes: globalT("Kyllä"),
    no: globalT("Ei"),
  };

  return (
    <Form.Field id={id}>
      <FieldHeader>{t(label)}</FieldHeader>
      {typeof value === "undefined" ? formContext.emptyValue : checked ? texts.yes : texts.no}
    </Form.Field>
  );
}

CheckboxWidget.defaultProps = {
  options: {
    semantic: {
      inverted: false,
    },
  },
};

export default CheckboxWidget;
